/*
  `← back` on product pages (phones; sections/header.liquid, docs/DESIGN-HANDOFF.md D6).

  Without this script it is a link to the product's drop, else the active drop, else shop all. With
  it, a visitor who came from another page of the shop goes back in the browser's history, so that
  page returns as they left it (shop all with its filters and scroll position, or the product they
  came from). The browser's history is the stack; nothing is stored.

  The link stays a link for a click with a modifier key (new tab or window), a visit from another site
  or without a referrer, and a page with nothing before it (a new tab). Entries inside this page (a
  skip link's #target) are stepped over where the Navigation API can tell; picking a size replaces
  the address (assets/product-info.js), so it adds none.
*/
if (!customElements.get('header-back')) {
  customElements.define(
    'header-back',
    class HeaderBack extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a[href]');
        if (!this.link) return;
        this.onClick = this.onClick.bind(this);
        this.link.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.link?.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        if (event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const steps = this.stepsBack();
        if (steps < 1) return;
        event.preventDefault();
        history.go(-steps);
      }

      // How many entries back the previous page is; 0 follows the link.
      stepsBack() {
        let referrer;
        try {
          referrer = new URL(document.referrer);
        } catch {
          return 0;
        }
        if (referrer.origin !== window.location.origin) return 0;

        const nav = window.navigation;
        if (!nav?.currentEntry || typeof nav.entries !== 'function') return history.length > 1 ? 1 : 0;
        // This shop's entries only, oldest first.
        const entries = nav.entries();
        const current = nav.currentEntry.index;
        let index = current - 1;
        while (index >= 0 && entries[index]?.sameDocument) index -= 1;
        return index >= 0 ? current - index : 0;
      }
    }
  );
}
